import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-transfer',
    templateUrl: './dlg-transfer.component.pug',
    styleUrls: ['./dlg-transfer.component.less'],
})
export class DlgTransferComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DlgTransferComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close(false);
    }

    onTransfer(value: number) {
        this.dialogRef.close(value);
    }
}
